import { DistanceUnitsEnum } from '@ubnt/link-core/enums';

import { availableCountries } from '@ubnt/wifi-calculator/utils/regulatoryLimits';
import { AppThunk } from 'app/store';
import {
  storedSettings,
  settingsUnitChange,
  settingsUserCountryUpdate,
  IMPERIAL_UNIT_COUNTRIES,
  settingsCountryUpdate,
} from 'modules/settings/slice';

export const applicationInit: () => AppThunk = () => async (dispatch) => {
  try {
    const geoipResponse = await fetch('https://www.ui.com/api/geoip', { method: 'POST' });
    const { country_code: country } = (await geoipResponse.json()) as { country_code: string };
    if (!storedSettings.country && availableCountries.includes(country)) {
      dispatch(settingsCountryUpdate({ country }));
    }
    if (!storedSettings.unit && IMPERIAL_UNIT_COUNTRIES.includes(country)) {
      dispatch(settingsUnitChange(DistanceUnitsEnum.Imperial));
    }
    dispatch(settingsUserCountryUpdate({ country }));
  } catch {
    // do nothing (should handle case when fetching user location fails?)
  }
};
